import type {
  OrganizationsBrandsLookupBrandItem,
  OrganizationsBrandsLookupItem,
} from "@src/domain/dto/organizationsBrands";

export interface OrgBrandMatch {
  organization: OrganizationsBrandsLookupItem;
  brand: OrganizationsBrandsLookupBrandItem;
}

export function findOrgBrandByKeys(
  organizations: OrganizationsBrandsLookupItem[],
  organizationKey: string,
  brandKey: string,
): OrgBrandMatch | null {
  const organization = organizations.find(
    (item) => item.organizationKey === organizationKey,
  );
  if (!organization) {
    return null;
  }

  const brand = (organization.brands ?? []).find(
    (item) => item.brandKey === brandKey,
  );
  if (!brand) {
    return null;
  }

  return { organization, brand };
}

export function findOrgBrandByBrandKey(
  organizations: OrganizationsBrandsLookupItem[],
  brandKey: string,
): OrgBrandMatch | null {
  for (const organization of organizations) {
    const brand = (organization.brands ?? []).find(
      (item) => item.brandKey === brandKey,
    );
    if (brand) {
      return { organization, brand };
    }
  }
  return null;
}
